import { CKButton, CKButtonProps } from 'clearkit';
import { useState } from 'react';

import SidebarDrawer from '~/components/SidebarDrawer';
import UpgradeAccountForm from '~/components/UpgradeAccountForm';

type UpgradeAccountFormButtonProps = CKButtonProps & {
  product?: string;
};

export function UpgradeAccountFormButton({
  children,
  ...rest
}: UpgradeAccountFormButtonProps) {
  const [showUpgradeForm, setShowUpgradeForm] = useState(false);

  return (
    <>
      <CKButton {...rest} onClick={() => setShowUpgradeForm(true)}>
        {children}
      </CKButton>
      <SidebarDrawer
        isVisible={showUpgradeForm}
        onToggle={() => {
          setShowUpgradeForm(!showUpgradeForm);
        }}
      >
        <UpgradeAccountForm
          onClose={() => {
            setShowUpgradeForm(false);
          }}
        />
      </SidebarDrawer>
    </>
  );
}
